import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14bdbdbe")

_pushScopeId("data-v-14bdbdbe")
const _hoisted_1 = { class: "search-template" }
const _hoisted_2 = {
  key: 0,
  class: "middle-header-text"
}
const _hoisted_3 = {
  key: 1,
  class: "middle-header-text"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "header-dummy" }, null, -1)
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "condition" }
const _hoisted_7 = { class: "button-area" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "center-align" }, "一覧に戻る", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "questionnaire-back" }, "アンケートをやり直す", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "すべて開く", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_12 = { class: "templates" }
const _hoisted_13 = {
  key: 0,
  class: "header famous"
}
const _hoisted_14 = {
  key: 1,
  class: "template-list"
}
const _hoisted_15 = {
  key: 2,
  class: "header nofamous"
}
const _hoisted_16 = {
  key: 3,
  class: "template-list"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MiddleHeader = _resolveComponent("MiddleHeader")
  const _component_fa = _resolveComponent("fa")
  const _component_SelectAttribute = _resolveComponent("SelectAttribute")
  const _component_SelectCheckboxAttribute = _resolveComponent("SelectCheckboxAttribute")
  const _component_Questionnaire = _resolveComponent("Questionnaire")
  const _component_TemplateThumbnail = _resolveComponent("TemplateThumbnail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MiddleHeader, null, {
      default: _withId(() => [
        (!_ctx.fromQ)
          ? (_openBlock(), _createBlock("p", _hoisted_2, " 使用するテンプレートを選んでください。条件を切替えて候補を変更することもできます。 "))
          : (_ctx.fromQ)
            ? (_openBlock(), _createBlock("p", _hoisted_3, " アンケートの回答内容に沿ったテンプレートを表示しています。使用するテンプレートを選んでください。条件を切替えて候補を変更することもできます。 "))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (!_ctx.fromQ)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "primary-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toSelectView && _ctx.toSelectView(...args)))
              }, [
                _createVNode(_component_fa, {
                  icon: ['fas', 'arrow-left'],
                  class: "left-align"
                }),
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          (_ctx.fromQ)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: "primary-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reSelect && _ctx.reSelect(...args)))
              }, [
                _createVNode(_component_fa, { icon: ['fas', 'arrow-left'] }),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          _createVNode("button", {
            class: "primary-button primary-button-2",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.allOpen && _ctx.allOpen(...args)))
          }, [
            _hoisted_10
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.helper.groupWithList, (withList) => {
          return _withDirectives((_openBlock(), _createBlock(_component_SelectAttribute, {
            key: withList.group.id,
            attributeGroup: withList.group,
            hideAttributeGroupID: _ctx.hideAttributeGroupID,
            selectedAttributeIDs: withList.selectedList.value,
            "onUpdate:selectedAttributeIDs": ($event: any) => (withList.selectedList.value = $event)
          }, null, 8, ["attributeGroup", "hideAttributeGroupID", "selectedAttributeIDs", "onUpdate:selectedAttributeIDs"])), [
            [_vShow, withList.group.id != _ctx.isCheckboxAttributeGroupID]
          ])
        }), 128)),
        _hoisted_11,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.helper.groupWithList, (withList) => {
          return _withDirectives((_openBlock(), _createBlock(_component_SelectCheckboxAttribute, {
            key: withList.group.id,
            attributeGroup: withList.group,
            selectedAttributeIDs: withList.selectedList.value,
            "onUpdate:selectedAttributeIDs": ($event: any) => (withList.selectedList.value = $event)
          }, null, 8, ["attributeGroup", "selectedAttributeIDs", "onUpdate:selectedAttributeIDs"])), [
            [_vShow, withList.group.id == _ctx.isCheckboxAttributeGroupID]
          ])
        }), 128)),
        _createVNode(_component_Questionnaire, {
          isShowModal: _ctx.isShowModal,
          "onUpdate:isShowModal": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModal = $event))
        }, null, 8, ["isShowModal"])
      ]),
      _createVNode("div", _hoisted_12, [
        (0 < _ctx.famousFilteredTemplates.length)
          ? (_openBlock(), _createBlock("p", _hoisted_13, " 有名作家作品 "))
          : _createCommentVNode("", true),
        (0 < _ctx.famousFilteredTemplates.length)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.famousFilteredTemplates, (template) => {
                return (_openBlock(), _createBlock(_component_TemplateThumbnail, {
                  key: template.id,
                  item: template
                }, null, 8, ["item"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (0 < _ctx.filteredTemplates.length)
          ? (_openBlock(), _createBlock("p", _hoisted_15, " 一般作家作品 "))
          : _createCommentVNode("", true),
        (0 < _ctx.filteredTemplates.length)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredTemplates, (template) => {
                return (_openBlock(), _createBlock(_component_TemplateThumbnail, {
                  key: template.id,
                  item: template
                }, null, 8, ["item"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})